import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router";
import "@/scss/index.scss";
import "@packages/component-library/style.css";
import "@packages/icon-library/style.css";
import "@packages/color-tokens/style.css";
import { eventBus } from "@/package/helpers/eventBus";
import { vSkeleton } from "@/package/directives/skeleton";
import * as Sentry from "@sentry/vue";

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.config.globalProperties.emitter = eventBus;
app.directive("skeleton", vSkeleton);

Sentry.init({
  app,
  dsn: "https://d7d945841b86fdd182c1a0253b8f0da9@sentry.iilab.ru/74",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.MODE === "production",
});

app.mount("#app");
